const COST_CENTERS_LES = process.env.VUE_APP_COST_CENTERS_LE?.split(',') || [];

export const isCostCentersAvailableForCountry = (country: string): boolean => {
  return COST_CENTERS_LES.includes(country);
};
